import React, { Fragment } from "react";
import {
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Row,
  Input,
  Form,
} from "reactstrap";
import Spinner from "../../Common/Spinner";
import { useState, useEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchSavedCandidatesRequest,
  resetSavedCandidates,
  deleteSavedCandidateRequest,
} from "../../../redux/recruiter/fetch_saved_candidates/actions";
import { Edit2, Trash2, Eye, Phone, Mail, Copy } from "react-feather";
import { Link } from "react-router-dom";
import { IoMdCopy } from "react-icons/io";
import { RiMailSendLine } from "react-icons/ri";
import { IoCallOutline } from "react-icons/io5";
import styled from "styled-components";
import {
  capitalize,
  formatDate,
  unslugAndCapitalize,
  handlePhoneCall,
  handleCopyToClipboard,
  handleSendEmail,
  generateSlug,
  formatToInteger,
  convertMonthsToYearsDecimal,
} from "../../../Components/Common/CommonFunction";
import { PreloaderContext } from "../../../_helper/Preloader/PreloaderContext";
import { showToast } from "../../Common/Toast";
import { LOADER_TIMEOUT, JOBSEEKER_PROFILE_IMAGE } from "../../../Constant";
import { showSweetAlert } from "../../Common/SweetAlert";
import { useNavigate } from "react-router-dom";
import { AVATAR } from "../../../Constant";
import NoDataFound from "../../Common/NoDataFound";
import { useParams } from "react-router-dom";
import { customStyles } from "../../../Constant";
import { emptyField } from "../../../Constant";
import PreviewResumeModal from "../Profile/PreviewResumeModal";
import { FiFileText } from "react-icons/fi";
import { formatExperienceOutput } from "../../../Components/Common/CommonFunction";
import { getCandidateStatusColor } from "../../../Constant";
import { DateRangePicker, defaultStaticRanges } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { addContactedCountRequest } from "../../../redux/jobseeker/add_contacted_count/actions";
import { addDays, startOfYear, endOfToday, subDays } from "date-fns";
import { FaCalendarAlt } from "react-icons/fa"; // FontAwesome calendar icon
import ViewCandidateDetailModal from "../ManageCandidate/ViewCandidateDetailModal";
import ChatModal from "../Chat/ChatModal";
import { LuMailPlus } from "react-icons/lu";
import ChatAppContext from "../../../Chat";
const SavedCandidates = () => {
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [selectedIds, setSelectedIds] = useState([]);
  const dispatch = useDispatch();
  const { showPreloader } = useContext(PreloaderContext);
  const { changeChat } = useContext(ChatAppContext) || {};

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [showPreviewResume, setShowPreviewResume] = useState(false);
  const [resumeData, setResumeData] = useState();
  const [datePickerOpen, setDatePickerOpen] = useState(false); // State to manage date picker visibility
  const [showViewCandidateDetails, setShowViewCandidateDetails] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [chatRecipient, setChatRecipient] = useState();


  const locale = {
    localize: {
      month: (monthIndex) => {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        return months[monthIndex];
      },
      day: (dayIndex) => {
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        return days[dayIndex];
      },
    },
    formatLong: {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    },
  };

  const customStaticRanges = [
    {
      label: "All",
      range: () => ({
        startDate: startOfYear(new Date()), // Start of current year
        endDate: endOfToday(), // Today
        type: "ALL",
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    },
    {
      label: "Your Candidate",
      range: () => ({
        startDate: startOfYear(new Date()), // Start of current year
        endDate: endOfToday(), // Today
        type: "YOUR_CANDIDATE",
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    },

    ...defaultStaticRanges.map((range) => ({
      ...range,
      range: () => ({
        ...range.range(),
        type: range.label.toUpperCase().replace(/ /g, "_"), // Generate a type from the label
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    })),
  ];

  const handleDateRangeChange = (ranges) => {
    const { selection } = ranges;
    let selectedType = "CUSTOM"; // Default to CUSTOM

    // Check if the selected range matches any predefined ranges
    for (let range of customStaticRanges) {
      const definedRange = range.range();
      if (
        selection.startDate.getTime() === definedRange.startDate.getTime() &&
        selection.endDate.getTime() === definedRange.endDate.getTime() &&
        selection.type === definedRange.type
      ) {
        selectedType = definedRange.type;
        break;
      }
    }

    setFormData({
      ...formData,
      dateRange: {
        ...selection,
        type: selectedType, // Set the type based on the selected range
      },
    });
    setDatePickerOpen(false); // Close the date picker after selecting a valid date range
  };

  const [formData, setFormData] = useState({
    dateRange: {
      key: "selection",
      // startDate: startOfYear(new Date()), // Start of current year
      // endDate: endOfToday(), // Today
      startDate: subDays(new Date(), 7), // Set start date to 7 days ago
      endDate: endOfToday(), // Set end date to today
      type: "ALL",
    },
  });

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      type: formData.dateRange.type,
      keyword: searchQuery,
      startDate: formData.dateRange.startDate
        ? formData.dateRange.startDate.toISOString()
        : "", // Convert Date objects to strings
      endDate: formData.dateRange.endDate
        ? formData.dateRange.endDate.toISOString()
        : "",
    };
    dispatch(fetchSavedCandidatesRequest(1, perPage, data, sortColumn, sortDirection));
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const handleDelete = (seeker_id) => {
    console.log("seeker_id", seeker_id);
    showSweetAlert("confirm", {
      message: "You want to delete the candidate",
      fun: deleteJob,
      id: seeker_id,
    });
  };

  const deleteJob = (seeker_id) => {
    dispatch(deleteSavedCandidateRequest({ saved_id: seeker_id }));
  };

  const handleRowSelected = (selectedRows) => {
    const selectedIds = selectedRows.selectedRows.map((row) => row.seeker_id);
    setSelectedIds(selectedIds);
  };

  const handleMailClick = (email, seekerId) => {
    handleSendEmail(email);
    dispatch(addContactedCountRequest({ seeker_id: seekerId })); // Dispatch your action with the necessary payload
  };

  const handlePhoneClick = (phone, seekerId) => {
    handlePhoneCall(phone);
    dispatch(addContactedCountRequest({ seeker_id: seekerId })); // Dispatch your action with the necessary payload
  };

  const handleCopyClick = (data, seekerId) => {
    handleCopyToClipboard(data);
    dispatch(addContactedCountRequest({ seeker_id: seekerId }));
  };

  const toggleViewCandidateDetailsModal = () => {
    setShowViewCandidateDetails(false);
  };

  const handleViewCandidateDetails = (row) => {

    setShowViewCandidateDetails(true);
    setResumeData(row);

  };

  const toggleChatModal = () => {
    setShowChatModal(false);
    setChatRecipient(null);
  };

  const handleChatClick = (row) => {
    changeChat(row);
    setChatRecipient(row);
    setShowChatModal(true);
  };

  // const tableColumns = [
  //   {
  //     name: "#",
  //     cell: (row, index) => (currentPage - 1) * perPage + index + 1,
  //     width: "60px",
  //     sortable: true,
  //     center: false,

  //   },
  //   {
  //     name: "Name",
  //     width: "15%",
  //     short_column: "jobseeker_full_name",
  //     cell: (row) => (
  //       <div className="d-flex align-items-center gap-2">
  //         <img
  //           className="img-fluid img-30 rounded-circle"
  //           // src={row.jobseeker_photo || AVATAR}
  //           src={row.jobseeker_photo
  //             ? row.jobseeker_photo
  //             : AVATAR}
  //           alt="user"
  //         />
  //         <Link
  //           to={`${process.env.PUBLIC_URL
  //             }/recruiter/job_candidate_detail/view/${generateSlug(
  //               row.jobseeker_full_name,
  //               row.jobseeker_location,
  //               row.seeker_id
  //             )}/${generateSlug(row.jobseeker_full_name, row.job_name, row.id)}`}
  //           title="View Candidate"
  //         >
  //           {capitalize(row.jobseeker_full_name.length > 15 ? row.jobseeker_full_name.substring(0, 15) + "..." : row.jobseeker_full_name) || "-"}
  //         </Link>
  //       </div>
  //     ),
  //     sortable: true,
  //     center: false,
  //   },
  //   {
  //     name: "Email",
  //     // short_column: "jobseeker_email1",
  //     // selector: (row) => (
  //     //   <span
  //     //     style={{ cursor: "pointer" }}
  //     //     onClick={() => handleSendEmail(row.jobseeker_email)}
  //     //   >
  //     //     {row.jobseeker_email || "-"}
  //     //   </span>
  //     // ),
  //     center: false,
  //     // sortable: true,
  //     width: "12%",
  //     cell: (row) => (
  //       <>
  //         {row.jobseeker_email1 ? (
  //           <span style={{ cursor: "pointer" }}>
  //             {row.jobseeker_email1 && (
  //               <>
  //                 <div className="mb-2">
  //                   <span
  //                     className="email-tooltip"
  //                     data-bs-toggle="tooltip"
  //                     data-bs-placement="top"
  //                     title={emptyField(row.jobseeker_email1.trim())}
  //                   >
  //                     {emptyField(row.jobseeker_email1.trim()).length > 12
  //                       ? emptyField(row.jobseeker_email1.trim()).substring(
  //                         0,
  //                         12
  //                       ) + "..."
  //                       : emptyField(row.jobseeker_email1.trim())}
  //                   </span>
  //                   <RiMailSendLine
  //                     className="email-icon ms-1"
  //                     title="Email"
  //                     size={17}
  //                     style={{ verticalAlign: "middle" }}
  //                     onClick={() =>
  //                       handleMailClick(row.jobseeker_email1, row.seeker_id)
  //                     }
  //                   />{" "}
  //                   <IoMdCopy
  //                     className="copy-icon"
  //                     size={17}
  //                     style={{ verticalAlign: "middle" }}
  //                     onClick={() =>
  //                       handleCopyClick(row.jobseeker_email1, row.seeker_id)
  //                     }
  //                     title="Copy"
  //                   />{" "}
  //                 </div>
  //               </>
  //             )}
  //             {/* {row.jobseeker_email2 && (
  //               <>
  //                 {emptyField(row.jobseeker_email2.trim()).length > 17
  //                   ? emptyField(row.jobseeker_email2.trim()).substring(0, 17) +
  //                     "..."
  //                   : emptyField(row.jobseeker_email2.trim())}
  //                 <Mail
  //                   size={18}
  //                   color="gray"
  //                   style={{
  //                     marginLeft: "5px",
  //                     marginRight: "5px",
  //                     cursor: "pointer",
  //                     verticalAlign: "middle",
  //                   }}
  //                   onClick={() => handleSendEmail(row.jobseeker_email2)}
  //                 />
  //                 <Copy
  //                   size={18}
  //                   color="gray"
  //                   style={{
  //                     marginLeft: "5px",
  //                     cursor: "pointer",
  //                     verticalAlign: "middle",
  //                   }}
  //                   onClick={() => handleCopyToClipboard(row.jobseeker_email2)}
  //                 />
  //               </>
  //             )} */}
  //           </span>
  //         ) : (
  //           "-" // Show hyphen if email data does not exist
  //         )}
  //         <br />
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Mobile No",
  //     // short_column: "jobseeker_phone1",
  //     center: false,
  //     // sortable: true, // Ensure this is set to true
  //     width: "10%",
  //     cell: (row) => (
  //       <>
  //         {row.jobseeker_phone1 ? (
  //           <span style={{ cursor: "pointer" }}>
  //             {row.jobseeker_phone1 && (
  //               <>
  //                 <div className="mb-2">
  //                   <span
  //                     className="email-tooltip"
  //                     data-bs-toggle="tooltip"
  //                     data-bs-placement="top"
  //                     title={emptyField(row.jobseeker_phone1.trim())}
  //                   >
  //                     {row.jobseeker_phone1.length > 10
  //                       ? `${row.jobseeker_phone1.trim().substring(0, 10)}...`
  //                       : row.jobseeker_phone1.trim()}
  //                   </span>
  //                   <IoCallOutline
  //                     className="phone-icon ms-1"
  //                     size={17}
  //                     style={{ verticalAlign: "middle", cursor: "pointer" }}
  //                     onClick={() =>
  //                       handlePhoneClick(row.jobseeker_phone1, row.seeker_id)
  //                     }
  //                     title="Call"
  //                   />{" "}
  //                   <IoMdCopy
  //                     className="copy-icon"
  //                     size={17}
  //                     style={{ verticalAlign: "middle" }}
  //                     onClick={() =>
  //                       handleCopyClick(row.jobseeker_phone1, row.seeker_id)
  //                     }
  //                     title="Copy"
  //                   />{" "}
  //                 </div>
  //               </>
  //             )}
  //             {/* {row.jobseeker_phone2 && row.country_code2 && (
  //               <>
  //                 {`${row.country_code2}${row.jobseeker_phone2.trim()}`}

  //                 <Phone
  //                   size={18}
  //                   color="gray"
  //                   style={{ marginLeft: "5px", cursor: "pointer" }}
  //                   onClick={() => handlePhoneCall(row.jobseeker_phone2)}
  //                 />
  //                 <Copy
  //                   size={18}
  //                   color="gray"
  //                   style={{ marginLeft: "5px", cursor: "pointer" }}
  //                   onClick={() => handleCopyToClipboard(row.jobseeker_phone2)}
  //                 />
  //               </>
  //             )} */}
  //           </span>
  //         ) : (
  //           "-" // Show hyphen if phone data does not exist
  //         )}
  //         <br />
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Location",
  //     // short_column: "jobseeker_location",
  //     cell: (row) => capitalize(row.jobseeker_location) || "-",
  //     // sortable: true,
  //     center: false,
  //     width: "12%",
  //   },
  //   {
  //     name: "Total Exp (Years)",
  //     sortable: true,
  //     short_column: "total_exp",
  //     center: true,
  //     // width: "8%",
  //     cell: (row) => {
  //       const experienceOutput = row.total_exp;
  //       return experienceOutput
  //         ? convertMonthsToYearsDecimal(experienceOutput)
  //         : "-";
  //       // return 4;
  //     },
  //   },
  //   {
  //     name: "Current CTC (LPA)",
  //     center: true,
  //     sortable: true,
  //     short_column: "current_salary",
  //     // width: "8%",
  //     cell: (row) => (
  //       <div style={{ textAlign: "center" }}>
  //         {(row.current_salary && row.current_salary) || "-"}
  //       </div>
  //     ),
  //   },
  //   {
  //     name: "EXP CTC (LPA)",
  //     sortable: true,
  //     short_column: "preferred_salary",
  //     center: true,
  //     // width: "7%",
  //     cell: (row) => (
  //       <div style={{ textAlign: "center" }}>
  //         {(row.preferred_salary &&
  //           row.preferred_salary) ||
  //           "-"}
  //       </div>
  //     ),
  //   },
  //   {
  //     name: "Notice Period (Days)",
  //     sortable: true,
  //     short_column: "jobseeker_notice_period",
  //     center: true,
  //     // width: "8%",
  //     cell: (row) =>
  //       row.jobseeker_notice_period ? `${row.jobseeker_notice_period}` : "-",
  //   },
  //   // {
  //   //   name: "Status",
  //   //   center: true,
  //   //   width: "90px",
  //   //   cell: (row) => (
  //   //     <span
  //   //       className={`badge ${getCandidateStatusColor(row.candidate_status)}`}
  //   //     >
  //   //       {unslugAndCapitalize(row.candidate_status)}
  //   //     </span>
  //   //   ),
  //   // },
  //   // {
  //   //   name: "Applied On",
  //   //   center: true,
  //   //   width: "120px",
  //   //   cell: (row) => formatDate(row.created_at) || "-",
  //   // },
  //   {
  //     width: "10%",
  //     name: "Actions",
  //     center: true,
  //     cell: (row) => (
  //       <div>
  //         <span>
  //           {/* <Link
  //             to={`${process.env.PUBLIC_URL
  //               }/recruiter/job_candidate_detail/view/${generateSlug(
  //                 row.jobseeker_full_name,
  //                 row.jobseeker_location,
  //                 row.seeker_id
  //               )}/${generateSlug(
  //                 row.jobseeker_full_name,
  //                 row.job_name,
  //                 row.id
  //               )}`}
  //             title="View Candidate"
  //           >
  //             <Eye
  //               size={18}
  //               className="eye-icon"
  //               style={{ marginRight: "7px" }}
  //             />
  //           </Link> */}
  //           <span title="View Candidate" style={{ cursor: "pointer", display: "inline-block" }}>
  //             <Eye
  //               onClick={() => handleViewCandidateDetails(row)} // Open modal and pass row data
  //               title="View Candidate"
  //               size={18}
  //               className="eye-icon"
  //               style={{ marginRight: "7px" }}
  //             />
  //           </span>
  //           <Link
  //             // to={`${
  //             //   process.env.PUBLIC_URL
  //             // }/recruiter/job_candidate_detail/edit/${generateSlug(
  //             //   row.jobseeker_full_name,
  //             //   row.jobseeker_location,
  //             //   row.seeker_id
  //             // )}/${generateSlug(
  //             //   row.jobseeker_full_name,
  //             //   row.job_name,
  //             //   row.id
  //             // )}`}
  //             to={`${process.env.PUBLIC_URL
  //               }/recruiter/job_candidate_detail/edit/${generateSlug(
  //                 row.jobseeker_full_name,
  //                 row.jobseeker_location,
  //                 row.seeker_id
  //               )}`}
  //             title="Edit Candidate"
  //           >
  //             {/* {row.uploaded_by && row.uploaded_by === row.seeker_id && ( */}
  //             <Edit2 size={18} className="edit-icon" style={{ marginRight: "7px" }} />
  //             {/* )} */}
  //           </Link>
  //           {row.jobseeker_resume && (
  //             <FiFileText
  //               size={18}
  //               className="file-icon"
  //               style={{ marginRight: "7px", cursor: "pointer" }}
  //               onClick={() => handlePreviewClick(row)}
  //               title="View Resume"
  //             />
  //           )}
  //           <span title="Delete Candidate">
  //             <Trash2
  //               size={18}
  //               onClick={() => handleDelete(row.saved_id)}
  //               className="delete-icon"
  //               style={{ cursor: "pointer" }}
  //             />
  //           </span>
  //         </span>
  //       </div>
  //     ),
  //   },
  // ];

  const tableColumns = [
    // {
    //   name: "#",
    //   cell: (row, index) => index + 1,
    //   width: "60px",
    //   sortable: true,
    // },
    {
      name: "Name",
      short_column: "candidate_name",
      sortable: true,
      grow: 3, // Takes the most of any extra space
      // minWidth: "170px",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <img
            className="img-fluid img-30 rounded-circle"
            src={row.jobseeker_photo ? row.jobseeker_photo : AVATAR}
            alt="user"
          />
          <Link
            to={`${process.env.PUBLIC_URL}/recruiter/job_candidate_detail/view/${generateSlug(
              row.jobseeker_full_name,
              row.jobseeker_location,
              row.seeker_id
            )}/${generateSlug(row.jobseeker_full_name, row.job_name, row.id)}`}
            title="View Candidate"
            style={{ overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}
          >
            {capitalize(row.jobseeker_full_name)}

          </Link>
        </div>
      ),
    },
    {
      name: "Email",
      sortable: true,
      short_column: "jobseeker_email1",
      grow: 2.5,
      minWidth: "80px", // Reduced from 180px
      cell: (row) => (
        <>
          {row.jobseeker_email1 ? (
            // flex-wrap allows icons to drop to a new line on very small screens
            <div className="d-flex flex-wrap align-items-center  w-100 gap-2">
              <span
                className="text-truncate" // Let flexbox and truncation handle the width
                data-bs-toggle="tooltip"
                title={emptyField(row.jobseeker_email1.trim())}
                style={{ cursor: 'pointer' }}
              >
                {emptyField(row.jobseeker_email1.trim())}
              </span>
              <div className="d-flex align-items-center gap-2 flex-shrink-0">
                <RiMailSendLine
                  className="email-icon"
                  title="Email"
                  size={17}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleMailClick(row.jobseeker_email1, row.seeker_id)}
                />
                <IoMdCopy
                  className="copy-icon"
                  size={17}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleCopyClick(row.jobseeker_email1, row.seeker_id)}
                  title="Copy"
                />
              </div>
            </div>
          ) : (
            "-"
          )}
        </>
      ),
    },
    {
      name: "Mobile No",
      sortable: true,
      short_column: "jobseeker_phone1",
      grow: 2,
      minWidth: "50px", // Reduced from 150px
      cell: (row) => (
        <>
          {row.jobseeker_phone1 ? (
            <div className="d-flex flex-wrap align-items-center  w-100 gap-2">
              <span
                className="text-truncate"
                data-bs-toggle="tooltip"
                title={emptyField(row.jobseeker_phone1.trim())}
                style={{ cursor: 'pointer' }}
              >
                {row.jobseeker_phone1.trim()}
              </span>
              <div className="d-flex align-items-center gap-2 flex-shrink-0">
                <IoCallOutline
                  className="phone-icon"
                  size={17}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handlePhoneClick(row.jobseeker_phone1, row.seeker_id)}
                  title="Call"
                />
                <IoMdCopy
                  className="copy-icon"
                  size={17}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleCopyClick(row.jobseeker_phone1, row.seeker_id)}
                  title="Copy"
                />
              </div>
            </div>
          ) : (
            "-"
          )}
        </>
      ),
    },
    {
      name: "Location",
      short_column: "jobseeker_location",
      sortable: true,
      grow: 1.5,
      minWidth: "115px", // Reduced from 120px
      cell: (row) => capitalize(row.jobseeker_location) || "-",
    },
    {
      name: "Total Exp (Year)",
      short_column: "total_exp",
      sortable: true,
      center: true,
      grow: 1,
      minWidth: "120px", // Reduced from 100px
      cell: (row) => (row.total_exp ? convertMonthsToYearsDecimal(row.total_exp) : "-"),
    },
    {
      name: "Current CTC (LPA)",
      short_column: "current_salary",
      sortable: true,
      center: true,
      grow: 1,
      minWidth: "110px", // Reduced from 110px
      cell: (row) => <div style={{ textAlign: "center" }}>{row.current_salary || "-"}</div>,
    },
    {
      name: "EXP CTC (LPA)",
      short_column: "preferred_salary",
      sortable: true,
      center: true,
      grow: 1,
      minWidth: "90px", // No change needed
      cell: (row) => <div style={{ textAlign: "center" }}>{row.preferred_salary || "-"}</div>,
    },
    {
      name: "Notice Period (Days)",
      short_column: "jobseeker_notice_period",
      sortable: true,
      center: true,
      grow: 1,
      minWidth: "150px", // Reduced from 130px
      cell: (row) => (row.jobseeker_notice_period ? `${row.jobseeker_notice_period}` : "-"),
    },
    {
      name: "Actions",
      center: true,
      width: "160px", // widened to keep icons in one line
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}>
          <span>
            {/* <Link
              to={`${process.env.PUBLIC_URL
                }/recruiter/job_candidate_detail/view/${generateSlug(
                  row.jobseeker_full_name,
                  row.jobseeker_location,
                  row.seeker_id
                )}/${generateSlug(
                  row.jobseeker_full_name,
                  row.job_name,
                  row.id
                )}`}
              title="View Candidate"
            >
              <Eye
                size={18}
                className="eye-icon"
                style={{ marginRight: "7px" }}
              />
            </Link> */}
            <span title="View Candidate" style={{ cursor: "pointer", display: "inline-block" }}>
              <Eye
                onClick={() => handleViewCandidateDetails(row)} // Open modal and pass row data
                title="View Candidate"
                size={18}
                className="eye-icon"
                style={{ marginRight: "5px" }}
              />
            </span>
            {row.applied_in_job !== false && (
              <Link
                // to={`${
                //   process.env.PUBLIC_URL
                // }/recruiter/job_candidate_detail/edit/${generateSlug(
                //   row.jobseeker_full_name,
                //   row.jobseeker_location,
                //   row.seeker_id
                // )}/${generateSlug(
                //   row.jobseeker_full_name,
                //   row.job_name,
                //   row.id
                // )}`}
                to={`${process.env.PUBLIC_URL
                  }/recruiter/job_candidate_detail/edit/${generateSlug(
                    row.jobseeker_full_name,
                    row.jobseeker_location,
                    row.seeker_id
                  )}`}
                title="Edit Candidate"
              >
                {/* {row.uploaded_by && row.uploaded_by === row.seeker_id && ( */}
                <Edit2 size={18} className="edit-icon" style={{ marginRight: "5px" }} />
                {/* )} */}
              </Link>
            )}
             <span title="Chat Candidate" style={{ cursor: "pointer", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>
              <LuMailPlus
                size={18}
                onClick={() => handleChatClick(row)}
                className="chat-icon"
              />
            </span>
            {row.jobseeker_resume && (
              <FiFileText
                size={18}
                className="file-icon"
                style={{ marginRight: "5px", cursor: "pointer" }}
                onClick={() => handlePreviewClick(row)}
                title="View Resume"
              />
            )}
            <span title="Delete Candidate">
              <Trash2
                size={18}
                onClick={() => handleDelete(row.saved_id)}
                className="delete-icon"
                style={{ cursor: "pointer" }}
              />
            </span>
            {/* <span title="Chat Candidate" style={{ cursor: "pointer", display: "inline-block", marginLeft: "5px" }}>
              <LuMailPlus
                size={18}
                onClick={() => handleChatClick(row)}
                className="chat-icon"
              />
            </span> */}
          </span>
        </div>
      ),
    },
  ];

  const togglePreviewResumeModal = () => {
    setShowPreviewResume(false);
  };

  const handlePreviewClick = (row) => {
    if (row.is_uploaded_resume) {
      setShowPreviewResume(true);
      setResumeData(row);
    }
  };

  const fetchSavedCandidatesReducerData = useSelector(
    (state) => state.fetchSavedCandidatesReducer
  );

  useEffect(() => {

    const data = {
      type: formData.dateRange.type,
      keyword: searchQuery,
      startDate: formData.dateRange.startDate
        ? formData.dateRange.startDate.toISOString()
        : "", // Convert Date objects to strings
      endDate: formData.dateRange.endDate
        ? formData.dateRange.endDate.toISOString()
        : "",
    };
    dispatch(fetchSavedCandidatesRequest(currentPage, perPage, data, sortColumn, sortDirection));
  }, [perPage, currentPage, formData]);

  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");

  const handleSort = async (column, direction) => {
    setSortColumn(column.short_column);
    setSortDirection(direction);
    // fetchJobs(); // Fetch jobs with new sorting

  };

  useEffect(() => {
    fetchCandidate()
  }, [perPage, currentPage, formData, sortColumn, sortDirection]);

  const fetchCandidate = () => {

    const data = {
      type: formData.dateRange.type,
      keyword: searchQuery,
      startDate: formData.dateRange.startDate
        ? formData.dateRange.startDate.toISOString()
        : "", // Convert Date objects to strings
      endDate: formData.dateRange.endDate
        ? formData.dateRange.endDate.toISOString()
        : "",

    };
    dispatch(fetchSavedCandidatesRequest(currentPage, perPage, data, sortColumn, sortDirection)); // Dispatch your action with the selected value

  };



  const candidateData = fetchSavedCandidatesReducerData.data.data;

  useEffect(() => {
    if (
      fetchSavedCandidatesReducerData.status &&
      fetchSavedCandidatesReducerData.message !== ""
    ) {
      showToast("success", fetchSavedCandidatesReducerData.message);
      dispatch(resetSavedCandidates());
      const data = {
        type: formData.dateRange.type,
        keyword: searchQuery,
        startDate: formData.dateRange.startDate
          ? formData.dateRange.startDate.toISOString()
          : "", // Convert Date objects to strings
        endDate: formData.dateRange.endDate
          ? formData.dateRange.endDate.toISOString()
          : "",
      };

      dispatch(fetchSavedCandidatesRequest(currentPage, perPage, data, sortColumn, sortDirection));
    } else if (
      fetchSavedCandidatesReducerData.status === false &&
      fetchSavedCandidatesReducerData.message !== ""
    ) {
      if (showPreloader) {
        setTimeout(() => {
          showToast("error", fetchSavedCandidatesReducerData.message);
        }, LOADER_TIMEOUT);
      } else {
        showToast("error", fetchSavedCandidatesReducerData.message);
      }
      dispatch(resetSavedCandidates());
    }
  }, [fetchSavedCandidatesReducerData]);

  return (
    <Fragment>
      <Row>
        <Col xs="12" className="box-col-12 xl-100">
          <Card>
            <CardHeader className="py-3">
              <div className="d-flex flex-wrap justify-content-between align-items-center">
                {/* Search Bar */}

                <Form
                  className="theme-form me-2 flex-grow-1"
                  onSubmit={handleSubmit}
                >
                  <div
                    className="input-group flex-nowrap "
                    style={{ height: 35, maxWidth: "350px" }}
                  >
                    <Input
                      className="form-control"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      type="search"
                      placeholder="Search.."
                    />
                    <Button
                      color="primary"
                      type="submit"
                      className="btn btn-primary input-group-text pe-3 ps-3"
                    >
                      Search
                    </Button>
                  </div>
                </Form>

                <div className="d-flex align-items-center ms-auto mt-3 mt-md-0">
                  <Button
                    color="primary"
                    id="shownCalendar"
                    onClick={() => setDatePickerOpen(!datePickerOpen)}
                    className="btn btn-primary d-flex align-items-center ps-3 pe-3"
                  >
                    <FaCalendarAlt className="" />
                    <span className="ms-2">
                      {formData &&
                        (formData.dateRange.type === "CUSTOM"
                          ? `${formatDate(
                            formData.dateRange.startDate,
                            "dd-MM-yyyy"
                          )} - ${formatDate(
                            formData.dateRange.endDate,
                            "dd-MM-yyyy"
                          )}`
                          : unslugAndCapitalize(formData.dateRange.type))}
                    </span>
                  </Button>
                  {datePickerOpen && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50px", // Adjust as needed based on your layout
                        right: "0",
                        zIndex: 1000,
                      }}
                    >
                      {/* <DefinedRange
                          onChange={handleDateRangeChange}
                          ranges={[formData.dateRange]}
                          open={datePickerOpen}
                        /> */}
                      <DateRangePicker
                        editableDateInputs
                        onChange={handleDateRangeChange}
                        ranges={[formData.dateRange]}
                        locale={locale}
                        direction="horizontal"
                        open={datePickerOpen}
                        onToggle={(open) => setDatePickerOpen(open)}
                        staticRanges={customStaticRanges}
                      />
                    </div>
                  )}
                </div>
              </div>
            </CardHeader>

            <CardBody className="px-0 py-3">

              <div className="table-container">
                <DataTable
                  responsive
                  customStyles={customStyles}
                  data={fetchSavedCandidatesReducerData.data.data}
                  columns={tableColumns}
                  striped={true}
                  center={true}
                  selectableRows
                  onSelectedRowsChange={handleRowSelected}
                  pagination
                  paginationServer
                  paginationTotalRows={fetchSavedCandidatesReducerData.data.total}
                  paginationPerPage={perPage}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerRowsChange}
                  progressPending={fetchSavedCandidatesReducerData.isLoading}
                  progressComponent={<Spinner />}
                  noDataComponent={
                    <NoDataFound message={"No candidates found"} />
                  }
                  onSort={(column, direction) => handleSort(column, direction)}
                /></div>

            </CardBody>
          </Card>
        </Col>
      </Row>
      {showPreviewResume && (
        <PreviewResumeModal
          isOpen={showPreviewResume}
          toggleModal={togglePreviewResumeModal}
          data={resumeData}
        />
      )}
      {showViewCandidateDetails && (
        <ViewCandidateDetailModal
          isOpen={showViewCandidateDetails}
          toggleModal={toggleViewCandidateDetailsModal}
          seekerId={resumeData && resumeData.seeker_id}
        />
      )}
      {showChatModal && (
        <ChatModal
          isOpen={showChatModal}
          toggleModal={toggleChatModal}
          recipient={chatRecipient}
        />
      )}
    </Fragment>
  );
};

export default SavedCandidates;
